import { render } from "./ContactoUp.vue?vue&type=template&id=208b1296&scoped=true"
import script from "./ContactoUp.vue?vue&type=script&lang=js"
export * from "./ContactoUp.vue?vue&type=script&lang=js"

import "./ContactoUp.vue?vue&type=style&index=0&id=208b1296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208b1296"]])

export default __exports__